import React from "react";
import _ from "lodash";

const View = ({ name, src, ...props }: any) => {
  return <video {...props} src={src} />;
};
export default View;
